<template>
  <div class="manual-scheduling">
    <!-- 科目列表栏 -->
    <div class="curriculum-management-topbar" v-loading="isCourseModuleListLoading" v-show="tableShow">
      <div class="topbar-title-container">
        <div class="topbar-title">
          <i class="iconfont icon-tips"></i>请拖动科目模块到对应的课节中
        </div>
        <div class="comeback-button-cotainter">
          <button class="comeback-button" v-if="isComebackButtonShow" @click="setCourseListAgain"
            v-hasPermi="'sc:coursearrange:edit'">
            <i class="iconfont icon-refresh comeback-icon" />重新设置科目
          </button>
        </div>
      </div>
      <div class="topbar-course-list-container">
        <div class="course-item-container" v-for="item in courseModuleList" :key="item.courseId" :draggable="true"
          @dragstart="courseItemDragStart($event, item)" @dragend="courseItemDragEnd"
          v-if="item.lessonsContent && item.courseName !== '总分'">
          <div class="course-item-icon-container">
            <img :src="$courseList[item.courseName]
              ? $courseList[item.courseName].courseIcon
              : $courseList['其他'].courseIcon
              " class="course-icon" :draggable="false" />
          </div>
          <div class="course-item-name-container">
            <span class="course-name">{{ item.courseName }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 课程表 -->
    <div class="curriculum-table-container" v-loading="isCurriculumTableLoading" v-show="tableShow">
      <!-- 表头容器 -->
      <div class="table-header-container">
        <!-- 课节 -->
        <div class="table-header-label lesson-label">
          <span>课节</span>
        </div>
        <div class="table-header-label lesson-label">
          <span>顺序</span>
        </div>
        <!-- 时间 -->
        <div class="table-header-label time-label">时间</div>
        <!-- 周一至周日 -->
        <div class="table-header-label week-label" v-for="(weekItem, weekIndex) in 7" :key="weekIndex" ref="weekLabel">
          星期{{
            weekIndex + 1 == 7 ? "天" : digitalToChineseWeek(weekIndex + 1)
          }}
        </div>
      </div>
      <!-- 表格横向容器 -->
      <div class="table-row-item-container" v-for="(
          lessonRowItem, lessonRowIndex
        ) in autoMaticListByClass.scheduleList" :key="lessonRowIndex">
        <!-- 课节名 -->
        <div class="table-row-item lesson-label-item">
          <span>{{ lessonRowItem.lessonsName }}</span>
        </div>
        <!-- 课节顺序 -->
        <div class="table-row-item lesson-label-item">
          {{
            lessonRowItem.lessonsSequence == -1
              ? ""
              : lessonRowItem.lessonsSequence
          }}
        </div>
        <!-- 时间 -->
        <div class="table-row-item time-item">
          <div class="time-gettime">
            <span class="time-value">{{ lessonRowItem.startTime }}</span>至<span class="time-value">{{
              lessonRowItem.endTime }}</span>
          </div>
          <!-- <div class="time-notset" v-else>
            <i class="iconfont icon-set time-icon" /><span class="time-value"
              >请设置时间段</span
            >
          </div> -->
        </div>
        <!-- 周一至周日课节 -->
        <div class="lesson-list-container">
          <div class="table-row-item lesson-content-item" v-for="(lessonItem, lessonIndex) in lessonRowItem.lessons"
            :key="lessonItem.id ? lessonItem.id : lessonIndex" :class="{
              checkedCourse:
                lessonItem.lessonsContent && lessonItem.scheduleState == '1',
              noScheduledCourse:
                lessonItem.lessonsContent && lessonItem.scheduleState == '0',
            }" :id="lessonIndex" @dragenter="lessonItemOnDragEnter($event, lessonItem)"
            @drop="lessonItemOndrop($event, lessonItem, lessonRowItem.lessonsSequence)" @dragover="lessonItemOnDragover"
            @dragleave="lessonItemOnDragLeave">
            <div class="lesson-content-container">
              <div class="content-container">
                <div class="content-course-icon-container" v-if="lessonItem.lessonsContent">
                  <img :src="$courseList[lessonItem.lessonsContent]
                    ? $courseList[lessonItem.lessonsContent].courseIcon
                    : $courseList['其他'].courseIcon
                    " class="content-course-icon" />
                </div>
                <div class="content-course-name-container">
                  <span class="content-course-name">{{
                    lessonItem.lessonsContent
                  }}</span>
                </div>
              </div>
              <div class="content-teacher-name-container">
                <span class="content-teacher-name">{{
                  lessonItem.teacherName
                }}</span>
              </div>
            </div>
            <div class="lesson-content-operation-mask" v-if="
              lessonItem.lessonsContent && lessonItem.scheduleState == '1'
            ">
              <button class="lesson-item-button detail" @click="showLessonDetail(lessonItem)">
                <i class="iconfont icon-detail button-icon" />
              </button>
              <button class="lesson-item-button delete" @click="
                deleteLessonItem(lessonRowItem, lessonIndex, lessonItem)
                ">
                <i class="iconfont icon-delete button-icon" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 提交 -->
    <div class="submit-container" v-show="tableShow" v-if="setState">
      <button class="submit-button" :disabled="!isGetCurriculumTableSuccess"
        :class="!isGetCurriculumTableSuccess ? 'notSetTime' : 'setComplate'" @click="submitCurriculumData"
        v-hasPermi="'sc:coursearrange:edit'">
        {{
          isGetCurriculumTableSuccess ? "保存提交课程编排" : "获取课程表失败"
        }}
      </button>
    </div>
    <!-- <div
      class="establish"
      v-show="!tableShow && curriculumShow"
      @click="changeEstablish"
      v-hasPermi="'sc:coursearrange:edit'"
    >
      暂无课程计划，点击进行课程编排 <i class="el-icon-right"></i>
    </div> -->
    <!-- 详情dialog -->
    <curriculumLessonDetail :classId="classId" :lessonDetail="checkedLessonDetail"
      :isCheckedLessonDetailDialogShow="isCheckedLessonDetailDialogShow" v-if="checkedLessonDetail"
      @lessonDetailDialogClose="lessonDetailDialogClose" @editCourseTeacherConfirm="editCourseTeacherConfirm" />
  </div>
</template>

<script>
import Vue from "vue";
//查看课节详情组件
import curriculumLessonDetail from "../curriculum-lesson-detail/curriculumLessonDetail";
import { v4 as uuidv4 } from "uuid";
export default {
  components: {
    curriculumLessonDetail,
  },
  data() {
    return {
      //课程表loading开关
      isCurriculumTableLoading: false,
      //已选择的一整行的课节
      checkedLessonRowItem: null,
      //已点击拖动的科目模块信息
      checkedCourseData: null,
      //已选择的课节详情
      checkedLessonDetail: null,
      //显示课节详情组件开关
      isCheckedLessonDetailDialogShow: false,
    };
  },
  props: {
    courseList: {
      type: Array,
    },
    courseModuleList: {
      type: Array,
    },
    defaultLessonNumber: {
      type: Number,
    },
    isComebackButtonShow: {
      type: Boolean,
    },
    isGetCurriculumTableSuccess: {
      type: Boolean,
    },
    tableShow: {
      type: Boolean,
    },
    isCourseModuleListLoading: {
      type: Boolean,
    },
    curriculumShow: {
      type: Boolean,
    },
    autoMaticListByClass: {
      type: [Array, Object],
    },
    className: {
      type: [Array, Object],
    },
    setState: {
      type: Boolean
    },
    classId: {
      type: [String, Number],
    }
  },
  // computed: {
  //   //有未设置的课节就不显示保存提交按钮
  //   isSubmitDisabled() {
  //     let notSetTimeLessons = [];
  //     for (let item of this.lessonList) {
  //       if (!item.startTime || !item.endTime) {
  //         notSetTimeLessons.push(item);
  //       }
  //     }
  //     if (notSetTimeLessons.length > 0) {
  //       return true;
  //     } else {
  //       return false;
  //     }
  //   },
  // },
  mounted() {
    // 记录星期的宽度，用于课程单元格宽度赋值
    this.$emit("weekLabelWidth", this.$refs.weekLabel[0].offsetWidth);
  },
  methods: {
    // 修改科任老师
    editCourseTeacherConfirm(data) {
      this.$emit("editCourseTeacherConfirm", data);
    },
    // 切换课程编排
    changeEstablish() {
      this.$emit("changeEstablish", this.className);
    },
    //点击重新编辑科目按钮，回到第一步
    setCourseListAgain() {
      // console.log("this.className:", this.className);
      let data = {
        className: this.className,
      };
      this.$emit("setCourseListAgain", data);
    },
    //数字转中文数字
    digitalToChinese(number) {
      // 判断是否为数字
      if (isNaN(number)) return number;
      const digit_arr = [
        "",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
      ];
      let chineseNumber;
      if (number < 10) {
        chineseNumber = digit_arr[number];
      } else if (number >= 10 && number < 20) {
        let arr = number.toString().split("");
        chineseNumber = number == 10 ? "十" : `十${digit_arr[arr[1]]}`;
      } else {
        let arr = number.toString().split("");
        chineseNumber = `${digit_arr[arr[0]]}十${digit_arr[arr[1]]}`;
      }
      return `第${chineseNumber}节`;
    },
    //数字转中文数字
    digitalToChineseWeek(number) {
      // 判断是否为数字
      if (isNaN(number)) return number;
      const digit_arr = [
        "",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
      ];
      let chineseNumber;
      if (number < 10) {
        chineseNumber = digit_arr[number];
      } else if (number >= 10 && number < 20) {
        let arr = number.toString().split("");
        chineseNumber = number == 10 ? "十" : `十${digit_arr[arr[1]]}`;
      } else {
        let arr = number.toString().split("");
        chineseNumber = `${digit_arr[arr[0]]}十${digit_arr[arr[1]]}`;
      }
      return chineseNumber;
    },
    courseItemDragStart(e, courseItem) {
      this.checkedCourseData = courseItem;
      e.dataTransfer.effectAllowed = "copyLink";
    },
    courseItemDragEnd() { },
    // 拖拽后添加阴影
    lessonItemOnDragEnter(e, lessonItem) {
      if (lessonItem.scheduleState == "0") return;
      let setHightLight;
      clearTimeout(setHightLight);
      setHightLight = setTimeout(() => {
        if (e.target.id) {
          e.target.classList.add("heightLight");
        }
      }, 0);
    },
    lessonItemOnDragLeave(e) {
      let removeHightLight;
      clearTimeout(removeHightLight);
      removeHightLight = setTimeout(() => {
        e.target.classList.remove("heightLight");
      }, 0);
    },
    lessonItemOndrop(e, lessonItem, lessonsSequence) {
      // console.log("className:", this.className);
      
      // console.log("被调换的==>", this.checkedCourseData, lessonItem, this.className);
      if (lessonItem.scheduleState == "0") return;
      let requestData = {
        classId: this.classId,
        className: this.className[1].className,
        teacherId: this.checkedCourseData.teacherId,
        teacherName: this.checkedCourseData.teacherName,
        classroomId: this.checkedCourseData.classroomId,
        classroomName: this.checkedCourseData.classroomName,
        week: lessonItem.week,
        lessons: lessonsSequence,
        // scheduleState: this.checkedCourseData.scheduleState,
        lessonsContent: this.checkedCourseData.lessonsName,
      };

      // console.log(requestData);

      // 调取手动调课检查接口
      this.post(this.$url.courseManualModifyCheck, requestData).then((res) => {
        const handleResponse = (msg) => {
          e.preventDefault();
          clearTimeout(window.removeHightLight);

          Object.keys(this.checkedCourseData).forEach(item =>
            Vue.set(lessonItem, item, this.checkedCourseData[item])
          );

          window.removeHightLight = setTimeout(() => {
            e.target.classList.remove("heightLight");
          }, 0);
        };

        if (res.code !== 200) {
          // 将 res.msg 数组转换为多行字符串
          const message = res.data.join('\n');
          this.$confirm(message, "课程冲突提醒", {
            confirmButtonText: "继续安排",
            cancelButtonText: "取消",
            type: "warning",
            confirmButtonClass: "confirm",
            customClass: 'custom-message-box', // 应用自定义类
          }).then(handleResponse).catch(() => { });
          return;
        }

        handleResponse();
      });
    },
    lessonItemOnDragover(e) {
      e.preventDefault();
      e.dataTransfer.dropEffect = "copyLink";
    },
    showLessonDetail(lessonItem) {
      // console.log("lessonItem:", lessonItem);
      this.checkedLessonDetail = lessonItem;
      this.isCheckedLessonDetailDialogShow = true;
    },
    lessonDetailDialogClose() {
      this.isCheckedLessonDetailDialogShow = false;
    },
    deleteLessonItem(lessonRowItem, lessonIndex) {
      // console.log("删除的ITEM==>", lessonRowItem, lessonIndex)
      lessonRowItem.lessons.splice(lessonIndex, 1, {
        week: lessonIndex + 1,
        courseId: "",
        courseName: "",
        classroomName: "",
        classroomId: "",
        teacherName: "",
        teacherNumber: "",
        teacherId: "",
        // courseIcon: "",
        scheduleState: "1",
      });
    },
    submitCurriculumData() {
      this.isCurriculumTableLoading = true;
      let data = [this.autoMaticListByClass];
      // console.log("autoMaticListByClass==>", data);
      this.post(this.$url.saveCourseArrangeListPC, data)
        .then((res) => {
          // console.log(res);
          if (res.code == 200 && res.data != 0) {
            this.isCurriculumTableLoading = false;
            // 重新编排顶部步骤显示切换
            this.$emit("isStepShowChange", false);
            return this.$message.success("提交保存成功");
          } else {
            this.isCurriculumTableLoading = false;
            return this.$message.error("提交保存失败!");
          }
        })
        .catch((err) => {
          this.$message.error("提交修改失败，请稍后再试");
        });
    },
  },
};
</script>

<style scoped lang="scss">
@import "./manual-scheduling.scss";
</style>

<style>
.custom-message-box {
  width: 750px !important; /* 使用 !important 提高优先级 */
  max-height: 400px;
  overflow: auto;
}</style>